import { Box, Flex, VStack } from "@chakra-ui/react";

/*
  Sticky bottom toolbar for kiosk page actions.
  Renders children (buttons, alerts) anchored to the viewport bottom.
*/
export default function KioskActionBar({ children, maxW = "container.xl" }) {
  return (
    <Box
      position="sticky"
      bottom={0}
      bg="white"
      borderTop="1px solid"
      borderColor="gray.200"
      boxShadow="0 -2px 8px rgba(0,0,0,0.06)"
      py={3}
    >
      <VStack spacing={3} maxW={maxW} mx="auto" w="full" px={{ base: 4, md: 8 }}>
        {children}
      </VStack>
    </Box>
  );
}
